import RootPage from './edelivery.page.vue'

let routes = [
  {
    path: 'edelivery',
    name: 'edelivery',
    component: RootPage
  },
]

export default routes
